import React from "react";

const CustomButton = ({type= "button", text="", className, click = () => {},tooltip="",disabled}) => {
  return (
    <button
      className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5 ${className}`}
      type={type}
      onClick={click}
      title={tooltip == "" ? text : tooltip}
      disabled={disabled}
    >
      {text}
    </button>
  );
};



export default CustomButton;
